import { render, staticRenderFns } from "./FailureStateCard.vue?vue&type=template&id=2f608be6&"
import script from "./FailureStateCard.vue?vue&type=script&lang=ts&"
export * from "./FailureStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports